import { render, staticRenderFns } from "./EditFivGoalModal.vue?vue&type=template&id=109669cc"
import script from "./EditFivGoalModal.vue?vue&type=script&lang=ts"
export * from "./EditFivGoalModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports